const BaseLine = () => {
  return (
    <div
      style={{ height: '0.5px', background: 'rgba(0,0,0,.2)', width: '100%' }}
    ></div>
  );
};

export default BaseLine;
